// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import Footer from "../components/Footer";
// import { getPublicCompanyAbout } from "../api/companyApi";

// const WhoAreWe = () => {


//   const { companyName } = useParams();

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchAbout = async () => {
//       try {
//         const res = await getPublicCompanyAbout(companyName);
//         if (res.success) {
//           setData(res.data);
//         } else {
//           setError(res.message || "Company not found");
//         }
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAbout();
//   }, [companyName]);

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <h4>Loading...</h4>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="text-center py-5 text-danger">
//         <h4>{error}</h4>
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* HERO */}
//       <section className="hero1">
//         <div className="container-lg">
//           <div className="row justify-content-center">
//             <div className="col-lg-8 py-4">
//               <h3 className="fw-bold text-uppercase">Who We Are</h3>
//               {/* <p className="text-muted">{data.companyName}</p> */}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* WHO WE ARE */}
//       <section className="features py-5">
//         <div className="container-lg">
//           <div className="row align-items-center g-4">
//             <div className="col-lg-6">
//               {data.whoWeAreImage ? (
//                 <img
//                   src={`https://api.voyagian.com${data.whoWeAreImage}`}
//                   alt="Who We Are"
//                   style={{ width: "100%", borderRadius: "10px" }}

//                 />
//               ) : (
//                 <div className="bg-light text-center p-5 rounded">
//                   No Image Available
//                 </div>
//               )}
//             </div>
//             <div className="col-lg-6">
//               <p>{data.whoWeAre || "No description available."}</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* VISION / MISSION / PURPOSE */}
//       <section className="py-5 features destination">
//         <div className="container-lg">
//           <div className="row g-4">
//             <div className="col-md-4">
//               <div className="info-card">
//                 <h5>Our Vision</h5>
//                 <p>{data.vision || "N/A"}</p>
//               </div>
//             </div>

//             <div className="col-md-4">
//               <div className="info-card">
//                 <h5>Our Mission</h5>
//                 <p>{data.mission || "N/A"}</p>
//               </div>
//             </div>

//             <div className="col-md-4">
//               <div className="info-card">
//                 <h5>Our Purpose</h5>
//                 <p>{data.purpose || "N/A"}</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default WhoAreWe;



import { useOutletContext } from "react-router-dom"
import Footer from "../components/Footer"
import { ROOT_API_URL } from "../config/apiConfig"

const WhoAreWe = () => {
  const { companyInfo, loading } = useOutletContext()

  if (loading) {
    return (
      <div className="text-center py-5">
        <h4>Loading...</h4>
      </div>
    )
  }

  const data = companyInfo

  if (!data) {
    return (
      <div className="text-center py-5 text-danger">
        <h4>Company not found</h4>
      </div>
    )
  }

  return (
    <>
      {/* HERO */}
      <section className="hero1">
        <div className="container-lg">
          <div className="row justify-content-center">
            <div className="col-lg-8 py-4">
              <h3 className="fw-bold text-uppercase">Who We Are</h3>
              {/* <p className="text-muted">{data.companyName}</p> */}
            </div>
          </div>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="features py-5">
        <div className="container-lg">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              {data.whoWeAreImage ? (
                <img
                  src={`${ROOT_API_URL}${data.whoWeAreImage}`}
                  alt="Who We Are"
                  style={{ width: "100%", borderRadius: "10px" }}
                />
              ) : (
                <div className="bg-light text-center p-5 rounded">No Image Available</div>
              )}
            </div>
            <div className="col-lg-6">
              <p>{data.whoWeAre || "No description available."}</p>
            </div>
          </div>
        </div>
      </section>

      {/* VISION / MISSION / PURPOSE */}
      <section className="py-5 features destination">
        <div className="container-lg">
          <div className="row g-4">
            <div className="col-md-4">
              <div className="info-card">
                <h5>Our Vision</h5>
                <p>{data.vision || "N/A"}</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card">
                <h5>Our Mission</h5>
                <p>{data.mission || "N/A"}</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card">
                <h5>Our Purpose</h5>
                <p>{data.purpose || "N/A"}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer socialMedia={data?.socialMedia} />
    </>
  )
}

export default WhoAreWe
